import { ValueOf } from '../utilities/types';

const dueDiligenceDatesToTrack = {
  ENTITY_CREATION_DATE: 'entityCreationDate',
  ENTITY_KYC: 'entityKyc',
  LAST_FORM_SUBMITTED_DATE: 'lastFormSubmittedDate',
  GROUP_ASSIGNMENT: 'groupAssignment',
} as const;

export type DueDiligenceDatesToTrack = ValueOf<typeof dueDiligenceDatesToTrack>;

export const dueDiligenceDateToTrackChoices = [
  { id: dueDiligenceDatesToTrack.ENTITY_CREATION_DATE, name: 'Entity creation date' },
  { id: dueDiligenceDatesToTrack.ENTITY_KYC, name: 'KYC approval date' },
  { id: dueDiligenceDatesToTrack.LAST_FORM_SUBMITTED_DATE, name: 'Last form submitted date' },
  { id: dueDiligenceDatesToTrack.GROUP_ASSIGNMENT, name: 'Group assignment date' },
];

export default dueDiligenceDatesToTrack;
